import {useTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import {BackendServices} from "../../../../../../../services";
import {useCookieContext} from "../../../../../../../contexts";
import {CourseOrderLocalItemResult} from "../../../../../../../services/courseOrder/models/CourseOrderType";
import {useNotification} from "../../../../../../../hooks/useNotification";
import {FileResult} from "../../../../../../../services/shared-models/sharedTypes";
import AttachmentCard from "../../../../../../../components/blocks/AttachmentCard";

export type  NotesType = {
    text: string | null | undefined,
    createdBy: string | null | undefined,
    attachments: FileResult[],
}

type WorkflowNotesProps = {
    order: CourseOrderLocalItemResult | null;
}



export function WorkflowNotes({order}: WorkflowNotesProps) {
 const { t } = useTranslation("Orders");
    const [loading, setLoading] = useState(false);
    const [lastNote, setLastNote] = useState<NotesType>();
    const { showNotification } = useNotification();
    const { isAr } = useCookieContext();

    useEffect(() => {
        if (order?.id) fetchOrderActions();
    }, [isAr, order]);
    const fetchOrderActions = async () => {
        try {
            setLoading(true);
            const res = await BackendServices.courseOrderService.getAllActionsCourseOrderByOrderId(order?.id ??0);
            if(!res.hasError)
            {
                setLastNote?.({
                    text: res?.data[res.data.length-1]?.notes,
                    createdBy: isAr? res.data[res.data.length-1]?.appliedBy?.arabicName : res.data[res.data.length-1]?.appliedBy?.englishName ,
                    attachments: res.data[res.data.length-1]?.attachments ?? [],
                });
            }

            setLoading(false);
        } catch (error) {
            showNotification({
                type: "error",
                description: t("errorGettingOrderActions"),
            });
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="position-relative">
            {lastNote?.text && (
                <div className="d-flex flex-column gap-2 px-4 text-dark">
                    <>
                        <h5 className="fw-bold">{t("previousNote")}</h5>
                        <div className={"d-flex flex-column gap-2"}>
                            <div className={""}>
                                <p>
                                    {lastNote.createdBy}:{` ${lastNote.text}`}
                                </p>
                                {lastNote.attachments&& lastNote.attachments.length>0 && <p> {t("attachments")}:</p>}
                            </div>
                            <div className={"d-flex"}>
                              
                                {  lastNote.attachments && lastNote.attachments.map((file: FileResult, index: number) => (
                                <AttachmentCard
                                    attachment={{
                                        extension: file.extension ?? "",
                                        fileName: file.name ?? "",
                                        id: file.id ?? "",
                                        size: file.size ?? "",
                                    }}
                                    
                                />
                                ))}
                            </div>
                        </div>
                       
                    </>
                </div>
            )}
        </div>
    );

}